import { render, staticRenderFns } from "./WordBreaker.vue?vue&type=template&id=55c23c58&scoped=true&"
import script from "./WordBreaker.vue?vue&type=script&lang=ts&"
export * from "./WordBreaker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c23c58",
  null
  
)

export default component.exports